import { MyWeddnChecklist } from "../../components/dashboard/MyWeddnChecklist";
import { ArrowLeft } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { Routes } from "../../routes/baseRoutes";

const MyWeddn = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const goBack = () => {
    if (location.key !== "default") navigate(-1);
    else navigate(Routes.dashboard);
  };

  return (
    <main className="relative mx-auto w-full max-w-3xl px-4 pb-28 pt-6 font-['font4'] md:px-8 md:pb-12 md:pt-10">
      <button
        type="button"
        onClick={goBack}
        aria-label="Go back"
        className="absolute -left-10 top-10 hidden h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-700 transition hover:border-slate-300 hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 lg:flex"
      >
        <ArrowLeft size={18} />
      </button>
      <div className="mb-7">
        <p className="mb-2 text-xs uppercase tracking-[0.22em] text-slate-500">Your wedding plan</p>
        <h1 className="text-3xl font-medium text-slate-950 md:text-4xl">My Weddn</h1>
        <p className="mt-3 max-w-xl text-sm leading-6 text-slate-600 md:text-base">
          Keep the important details in one place. Some tasks update automatically as you use Weddn, and you can check off, edit, or add the rest.
        </p>
      </div>
      <section>
        <MyWeddnChecklist />
      </section>
    </main>
  );
};

export default MyWeddn;
